import React from "react";
import { Reveal, RevealImage } from "@/lib/motion";
import { Page, PageHero, CTABand } from "@/components/shared";
import { useContent } from "@/lib/ContentProvider";

// varied heights for a masonry-like editorial grid
const SPANS = ["md:row-span-2", "", "", "md:row-span-2", "", ""];

export default function Gallery() {
  const { gallery } = useContent();
  return (
    <Page testid="gallery-page">
      <PageHero
        overline="Gallery"
        titleLines={["Inside", <span key="2">our <span className="italic text-alch-terracotta">hospital</span></span>]}
        subtitle="A glimpse of our facility, advanced technology, and the team behind thousands of successful procedures."
      />

      <section className="px-5 py-24 md:px-8 md:py-32">
        <div className="mx-auto grid max-w-7xl auto-rows-[16rem] grid-cols-1 gap-5 md:grid-cols-3">
          {gallery.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className={`group ${SPANS[i % SPANS.length]}`}>
              <div className="relative h-full overflow-hidden rounded-[1.5rem]">
                <RevealImage src={g.url} alt={g.cap} className="h-full" imgClassName="transition-transform duration-[900ms] group-hover:scale-105" />
                <div className="absolute inset-0 flex items-end bg-gradient-to-t from-alch-forest/60 via-transparent to-transparent p-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="font-serif text-2xl text-alch-bg">{g.cap}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </Page>
  );
}
